import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    title: {
      fontWeight: 700,
      fontSize: '20px',
      textAlign: 'center',
    },
    closeIcon: {
      position: 'absolute',
      right: '15px',
      top: '15px',
      cursor: 'pointer',
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'Roboto',
      padding: '1rem 2rem',
      gap: '15px',
    },
    textTitle: {
      fontWeight: 700,
      fontSize: '16px',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    text: {
      fontWeight: 400,
      fontSize: '16px',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    link: {
      color: 'rgba(41, 121, 255, 0.87)',
    },
    button: {
      cursor: 'pointer',
      textTransform: 'uppercase',
    }
  }
))
